import { useEffect } from 'react';
import { FaMoneyBillWave, FaPercent } from 'react-icons/fa';
import InputField from '../../../Components/InputField';
import Button from '../../../Components/Button';
import Alert from '../../../Components/Alert';
import useUpdateServiceCommission from '../../../Hooks/Services/useUpdateServiceCommission';
import Loading from '../../../Components/Loading';

const UpdateServiceCommission = ({ commission, onSuccess }) => {
    const { values, errors, error, success, isLoading, handleChange, handleSubmit, setValues } = useUpdateServiceCommission(commission.id, { onSuccess });

    useEffect(() => {
        if (commission) {
            setValues({
                commission: commission.commission || ''
            });
        }
    }, [commission, setValues]);

    return (
        <div className="p-6">
            <div className="max-w-md mx-auto">
                <div className="text-center mb-6">
                    <div className="w-16 h-16 bg-main1/10 rounded-full flex items-center justify-center mx-auto mb-4">
                        <FaMoneyBillWave className="text-3xl text-main1" />
                    </div>
                    <h3 className="text-xl font-bold text-main1 mb-2">تحديث نسبة العمولة</h3>
                    <p className="text-sm text-gray-600">تحديث نسبة عمولة خدمة {commission?.service}</p>
                </div>

                <form className="space-y-6" onSubmit={handleSubmit}>
                    <div>
                        <InputField
                            className="p-3"
                            placeholder="نسبة العمولة"
                            Icon={FaPercent}
                            type="number"
                            step="0.01"
                            name="commission"
                            value={values.commission}
                            onChange={handleChange}
                            error={errors.commission}
                        />
                    </div>

                    <Button 
                        type="submit" 
                        className="mt-6"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <div className="flex items-center gap-3 m-1">
                                <Loading type="dots" size="md" text="جاري التحديث ..." color="light" />
                            </div>
                        ) : (
                            'تحديث العمولة'
                        )}
                    </Button>
                </form>

                {error && <Alert type="error">{error}</Alert>}
                {success && <Alert type="success">{success}</Alert>}
            </div>
        </div>
    );
};

export default UpdateServiceCommission;
